import { useCallback } from "react";
import { CARD_WIDTH } from "../constants";
import {
  CompareSchoolArrow,
  CompareSchoolsSquare
} from "../../../../utils/DataLayers";

const useNavigation = (containerRef, ipedsId) => {
  const next = useCallback(() => {
    CompareSchoolArrow({ ipeds: ipedsId });
    if (!containerRef.current) return;

    const container = containerRef.current;
    const maxScroll = container.scrollWidth - container.clientWidth;
    const nextScrollPosition = container.scrollLeft + CARD_WIDTH;

    if (nextScrollPosition <= maxScroll) {
      container.scrollTo({
        left: nextScrollPosition,
        behavior: "smooth"
      });
    }
  }, [containerRef, ipedsId]);

  const previous = useCallback(() => {
    CompareSchoolArrow({ ipeds: ipedsId });
    if (!containerRef.current) return;

    const container = containerRef.current;
    const prevScrollPosition = container.scrollLeft - CARD_WIDTH;

    if (prevScrollPosition >= 0) {
      container.scrollTo({
        left: prevScrollPosition,
        behavior: "smooth"
      });
    }
  }, [containerRef, ipedsId]);

  const navigateTo = useCallback(
    (index) => {
      CompareSchoolsSquare({ ipeds: ipedsId });

      if (!containerRef.current) return;

      containerRef.current.scrollTo({
        left: index * CARD_WIDTH,
        behavior: "smooth"
      });
    },
    [containerRef, ipedsId]
  );

  return {
    next,
    previous,
    navigateTo
  };
};

export default useNavigation;
